import React, { PureComponent, ReactNode } from 'react'
import { DispatchProp } from 'react-redux'
import { connectRedux } from '../../helpers/connectRedux'
import { Link } from 'react-router-dom'
import { RouteComponentProps, withRouter } from '../../helpers/withRouter'

import { images } from '../../images'
import { IMenuOption } from '../../models'
import { urls } from '../../routing'
import { LiteralsService } from '../../services'
import { signOutAction } from '../../store/actions'
import { IStoreState } from '../../store/states'
import { Dropdown } from './../../components'
import StyledSection from './styles'
import { appsLogosSelected, appsPenaltiesSelected, appsTemporalPassesSelected } from '../../helpers/app'
import { AnyAction } from 'redux'

interface IProps extends DispatchProp<AnyAction>, RouteComponentProps {
  username: string
  lastname: string
}

interface IState {
  isMobile: boolean
  menuOpen: boolean
}

class Menu extends PureComponent<IProps, IState> {
  private get accountOptions(): IMenuOption[] {
    return [
      { icon: 'close', label: LiteralsService.get('closeSession', true), action: this.handleSignOut }
    ]
  }

  private get isReservationTabActive(): boolean {
    const { history } = this.props
    return history.location.pathname.includes(urls.reservations)
      || history.location.pathname.includes(urls.pastReservations)
  }

  private get isWalletTabActive(): boolean {
    const { history } = this.props
    return history.location.pathname.includes(urls.wallet)
  }

  private get isPenaltiesTabActive(): boolean {
    const { history } = this.props
    return history.location.pathname.includes(urls.penalties)
  }

  private get isFavoritesTabActive(): boolean {
    const { history } = this.props
    return history.location.pathname.includes(urls.favorites)
  }

  private get isConfigurationTabActive(): boolean {
    const { history } = this.props
    return history.location.pathname.includes(urls.configuration.configurationDisplay) ||
           history.location.pathname.includes(urls.configuration.userInfo) ||
           history.location.pathname.includes(urls.configuration.changePassword) ||
           history.location.pathname.includes(urls.configuration.changeLanguage) ||
           history.location.pathname.includes(urls.configuration.areaSelection) ||
           history.location.pathname.includes(urls.configuration.notificationSettings) ||
           history.location.pathname.includes(urls.configuration.unsubscribe) ||
           history.location.pathname.includes(urls.configuration.information)
  }

  private get sectionTitle(): string {
    if (this.isReservationTabActive) return LiteralsService.get('reservations', true)
    if (this.isFavoritesTabActive) return LiteralsService.get('favorites', true)
    if (this.isWalletTabActive) return LiteralsService.get('wallet', true)
    if (this.isPenaltiesTabActive) return LiteralsService.get('penalites', true)
    if (this.isConfigurationTabActive) return LiteralsService.get('configuration', true)
    return ''
  }

  constructor(props: IProps) {
    super(props)

    this.state = {
      isMobile: window.innerWidth <= 768,
      menuOpen: false
    }
  }

  public render(): ReactNode {
    const { username, lastname } = this.props
    const { isMobile, menuOpen } = this.state

    return (
      <StyledSection>
        <section className={ appsLogosSelected?.class }>
          <img src={ appsLogosSelected?.logo } alt={appsLogosSelected?.alt}/>
        </section>
        <section className='menu-burger' onClick={ this.handleNavigation }>
          <img src={images.menuBurger} />
          <label> { this.sectionTitle } </label>
        </section>
        <section className={`navigation ${isMobile && menuOpen ? 'mobile open' : ''}`}>
          <Link
            className={ this.isReservationTabActive ? 'active' : '' }
            to={ urls.reservations }
            onClick={ this.handleNavigation }
          >
            { LiteralsService.get('reservations') }
          </Link>
          <Link
            className={ this.isFavoritesTabActive ? 'active' : '' }
            to={ urls.favorites }
            onClick={ this.handleNavigation }
          >
            { LiteralsService.get('favorites') }
          </Link>
          {
            appsTemporalPassesSelected?.enabled &&
            <Link
              className={ this.isWalletTabActive ? 'active' : '' }
              to={ urls.wallet }
              onClick={ this.handleNavigation }
            >
              { LiteralsService.get('wallet') }
            </Link>
          }
          {
            appsPenaltiesSelected?.enabled &&
            <Link
              className={ this.isPenaltiesTabActive ? 'active' : '' }
              to={ urls.penalties }
              onClick={ this.handleNavigation }
            >
              { LiteralsService.get('penalites') }
            </Link>
          }
          <Link
            className={ this.isConfigurationTabActive ? 'active' : '' }
            to={ urls.configuration.configurationDisplay }
            onClick={ this.handleNavigation }
          >
            { LiteralsService.get('configuration') }
          </Link>
        </section>
        <section className="account">
          <Dropdown options={ this.accountOptions }>
            <p className="username">
              <img src={ images['avatar'] } alt="User"/>
              <span>
                { username } { lastname }
              </span>
            </p>
          </Dropdown>
        </section>
      </StyledSection>
    )
  }

  private handleSignOut = () => this.props.dispatch(signOutAction())

  private handleNavigation = () => {
    const { menuOpen } = this.state
    this.setState({
      menuOpen: !menuOpen
    })
  }
}

const mapStateToProps = ({ userInfo }: IStoreState) => ({
  username: userInfo.firstName,
  lastname: userInfo.lastName
})

export default withRouter(connectRedux(mapStateToProps, Menu))
